import { appendErrorDetails } from './appendErrorDetails';

export const getErrorMessage = (ex: unknown, defaultError?: string) => {
  const details = appendErrorDetails(ex);
  if (defaultError) return defaultError + details;

  return ((ex as any)?.message || 'Something went wrong.') + details;
};
